import { ButtonBS, Center } from "@biblioteksentralen/react";
import { LinkButton } from "@libry-content/types";
import { PortableTextTypeComponentProps } from "@portabletext/react";
import { PropsWithChildren } from "react";
import { ExternalLink } from "react-feather";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { isUrlInternal } from "../../utils/isUrlInternal";
import { useCommonData } from "../layout/CommonDataProvider";

type Props = PropsWithChildren<PortableTextTypeComponentProps<LinkButton>>;

export function TextLinkButtonSerializer({ value }: Props) {
  const { ts } = useTranslation();
  const isInternal = isUrlInternal(useCommonData().site, value.url);
  if (!ts(value?.label) || !value?.url) return null;

  return (
    <Center marginY="2rem">
      <ButtonBS as="a" variant="secondary" href={value.url} rel={isInternal ? undefined : "noopener noreferrer"}>
        {ts(value.label)}
        {!isInternal && <ExternalLink />}
      </ButtonBS>
    </Center>
  );
}
